/**
 * Talks to the Chalice /profile endpoint.
 * Sends the Cognito ID token as the Bearer for the API Gateway
 * Cognito authorizer (see backend/app.py).
 */
import { Kid } from '../auth/cognito';

// Strip any trailing slash so `${API_BASE}/profile` never produces `/api//profile`.
const API_BASE = (import.meta.env.VITE_API_BASE_URL as string).replace(/\/+$/, '');

export type Role = 'parent' | 'coach' | 'partner';

export type ParentProfile = {
  cognitoSub: string;
  role: Role;
  parentName: string;
  email: string;
  phoneNumber: string;
  kids: Kid[];
  createdAt: string;
};

export async function createProfile(
  idToken: string,
  body: { role: Role; parentName: string; phoneNumber: string; kids: Kid[] },
): Promise<ParentProfile> {
  const res = await fetch(`${API_BASE}/profile`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`createProfile failed: ${res.status} ${await res.text()}`);
  return res.json();
}

export async function getProfile(idToken: string): Promise<ParentProfile | null> {
  const res = await fetch(`${API_BASE}/profile`, {
    headers: { Authorization: `Bearer ${idToken}` },
  });
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(`getProfile failed: ${res.status}`);
  return res.json();
}
